<template>
    <div>
        <h1>솔닥 마이데이터 서비스 이용약관</h1>
        <h2>제1장 총칙</h2>
        <h3>제1조 (목적)</h3>
        이 약관은 주식회사 솔닥(이하 “회사”라 합니다)이 제공하는 솔닥 마이데이터 서비스의 이용과 관련하여 회사와 회원 사이의 권리, 의무 및 책임사항, 서비스 이용 조건과 절차, 기타 필요한 사항을 정함을 목적으로 합니다.<br>
        <h3>제2조 (용어의 정의)</h3>
         이 약관에서 사용하는 용어의 뜻은 다음과 같습니다.<br>
        1. “솔닥 마이데이터 서비스”란 회원의 개인정보 전송요구에 따라 한국보건의료정보원 건강정보 고속도로 API 등을 통해 보건의료정보전송자로부터 전송받은 건강정보를 솔닥 서비스 내에서 조회, 관리, 활용할 수 있도록 회사가 제공하는 서비스를 말합니다.<br>
        2. “회원”이란 솔닥 서비스에 가입하고 이 약관에 동의하여 솔닥 마이데이터 서비스를 이용하는 자를 말합니다.<br>
        3. “건강정보”란 회원의 전송요구에 따라 회사가 보건의료정보전송자로부터 전송받는 진료이력, 진단내역, 처방내역, 투약이력, 건강검진정보, 암검진정보, 예방접종정보, 검사결과, 수술 및 처치내역, 알레르기 및 부작용 정보 등 회원의 건강에 관한 정보를 말합니다.<br>
        4. “보건의료정보전송자”란 회원의 전송요구에 따라 건강정보를 전송하는 의료기관, 국민건강보험공단, 건강보험심사평가원, 질병관리청 등 관계 법령에서 정한 기관을 말합니다.<br>
        5. “중계전문기관”이란 보건의료정보전송자와 특수전문기관 사이에서 개인정보 전송 중계에 필요한 기능을 제공하고 관련 시스템을 운영하는 기관으로 한국보건의료정보원을 의미합니다.<br>
        6. “특수전문기관”이란 통합조회, 맞춤형 서비스 등을 위하여 보건의료정보전송자로부터 전송받은 정보를 관리·분석하는 정보수신자를 말하며, 본 서비스에서 회사가 이에 해당할 수 있습니다.<br>
        7. “전송요구”란 회원이 자신의 결정에 의하여 관계 법령에 따라 보건의료정보전송자에게 본인의 건강정보를 회사로 전송하도록 요구하는 것을 말합니다.<br>
        8. “연동 해지”란 회원이 솔닥 마이데이터 서비스에서 특정 기관 또는 전체 마이데이터 연동을 종료하는 것을 말합니다.<br>
        9. “제3자 제공”이란 회사가 회원의 동의를 받아 회원의 건강정보를 의료기관, 의료진, EMR 시스템 등 회사 외의 제3자에게 제공하는 것을 말합니다.<br>
         이 약관에서 정하지 않은 용어의 의미는 관련 법령, 개인정보처리방침 및 서비스 화면의 안내에 따릅니다.<br>
        <h3>제3조 (약관의 게시와 개정)</h3>
        1. 회사는 회원이 이 약관의 내용을 쉽게 확인할 수 있도록 솔닥 서비스 화면 또는 연결 화면에 게시합니다.<br>
        2. 회사는 관련 법령을 위반하지 않는 범위에서 이 약관을 개정할 수 있습니다.<br>
        3. 회사가 약관을 개정하는 경우 적용일자, 개정 내용 및 개정 사유를 명시하여 적용일 전까지 서비스 화면 또는 기타 적절한 방법으로 공지합니다. 다만, 회원에게 불리하거나 중요한 사항이 변경되는 경우에는 관련 법령에서 정한 방법에 따라 사전 고지합니다.<br>
        4. 회원이 제3항에 따른 공지기간 내에 명시적인 거부 의사를 표시하지 않는 경우에는 개정 약관에 동의한 것으로 봅니다. 회원이 개정 약관에 동의하지 않는 경우 언제든지 솔닥 마이데이터 서비스 이용을 중단하거나 해지할 수 있습니다.<br>
        <h2>제2장 서비스의 내용 및 이용</h2>
        <h3>제4조 (서비스의 내용)</h3>
         회사는 회원에게 다음 각 호의 솔닥 마이데이터 서비스를 제공할 수 있습니다.<br>
        1. 보건의료정보전송자로부터 전송받은 건강정보의 조회 및 통합 관리<br>
        2. 연동기관, 연동항목, 전송요구 기간, 정기전송 여부 및 주기 확인<br>
        3. 전송요구 내역, 전송 상태, 연동 해지 및 철회 내역 조회<br>
        4. 건강정보의 요약, 분류, 시각화 등 조회 편의를 위한 기능<br>
        5. 회원이 선택한 건강정보를 진료 예약, 비대면 진료, 대면 진료 등 의료서비스 이용 과정에서 의료기관 또는 의료진에게 제공하는 기능<br>
        6. 맞춤형 건강정보, 건강 콘텐츠, 건강관리 서비스 제공<br>
        7. 기타 회사가 솔닥 마이데이터 서비스 제공을 위해 필요하다고 판단하는 기능<br>
         제1항 각 호의 서비스 중 일부는 회원이 각 서비스 이용에 별도 동의한 경우에 한하여 제공될 수 있습니다.<br>
        <h3>제5조 (서비스 이용 조건)</h3>
        1. 솔닥 마이데이터 서비스는 본인 확인 및 관계 법령에서 정한 전송요구 절차를 완료한 회원에게 제공됩니다.<br>
        2. 회원은 솔닥 마이데이터 서비스를 이용하기 위해 본 약관에 동의해야 하며, 그 외 건강정보 고속도로 이용약관, 건강정보 고속도로 개인정보 처리 관련 동의, 회사의 개인정보 수집·이용 동의, 민감정보 수집·이용 동의 및 기타 필요한 동의를 완료해야 할 수 있습니다.<br>
        3. 회원이 필수 동의에 동의하지 않거나 전송요구 절차를 완료하지 않은 경우, 솔닥 마이데이터 서비스의 전부 또는 일부 이용이 제한될 수 있습니다.<br>
        4. 회사는 회원의 인증정보와 솔닥 본인 프로필 정보가 일치하는지 확인할 수 있으며, 정보가 일치하지 않는 경우 마이데이터 연동 또는 건강정보 제공을 제한할 수 있습니다.<br>
        <h3>제6조 (전송요구 및 건강정보 연동)</h3>
        1. 회원은 솔닥 마이데이터 서비스를 이용하기 위해 전송요구 목적, 전송요구를 받는 전송요구 대상 기관, 전송을 받는 정보수신자, 전송을 요구하는 개인정보 항목, 정기전송 여부 및 주기, 전송요구 종료시점, 보유 및 이용기간 등을 확인한 후 전송요구를 진행합니다.<br>
        2. 회사는 회원의 전송요구에 따라 보건의료정보전송자로부터 건강정보를 전송받을 수 있습니다. 회원은 보건의료정보전송자에게 해당 건강정보의 정확성 및 최신성이 유지될 수 있도록 정기적으로 전송하여 줄 것을 요구할 수 있습니다.<br>
        3. 한국보건의료정보원 등 중계전문기관은 보건의료정보전송자와 회사 사이에서 건강정보 전송을 중계할 수 있습니다.<br>
        4. 회사는 회원이 전송요구한 항목 및 동의한 범위 내에서만 건강정보를 수신하고 이용합니다. 회원은 언제든지 본 조에 따른 전송요구를 철회할 수 있습니다.<br>
        5. 전송요구 가능 기관, 전송 가능 항목, 조회 가능 기간, 정기전송 여부 및 주기는 보건의료정보전송자, 중계전문기관, 관련 법령, 서비스 정책에 따라 달라질 수 있습니다.<br>
        <h3>제7조 (연동기관 및 연동항목 관리)</h3>
        1. 회원은 솔닥 마이데이터 관리 화면에서 연동기관, 연동항목, 마지막 업데이트일, 전송요구 종료시점, 전송 상태 등을 확인할 수 있습니다.<br>
        2. 회원은 관계 법령 및 회사가 정한 절차에 따라 전송요구 항목을 변경하거나 연동을 해지할 수 있습니다.<br>
        3. 전송요구 항목 변경은 기존 전송요구의 단순 설정 변경이 아니라, 새로운 전송요구 또는 전송요구서 재작성 절차로 처리될 수 있습니다.<br>
        4. 회원이 특정 기관 또는 전체 마이데이터 연동을 해지하는 경우 회사는 해당 전송요구에 따른 신규 건강정보 조회를 중단합니다.<br>
        <h2>제3장 건강정보의 처리</h2>
        <h3>제8조 (건강정보의 수집·이용)</h3>
        1. 회사는 회원의 동의 및 전송요구에 따라 건강정보를 수집·이용합니다.<br>
        2. 회사는 건강정보를 다음 각 호의 목적으로 이용할 수 있습니다.<br>
        ① 솔닥 앱 내 건강정보 조회 및 통합 관리<br>
        ② 건강정보 요약, 분류, 시각화 등 서비스 제공<br>
        ③ 진료 예약, 비대면 진료, 대면 진료 등 의료서비스 이용 시 회원이 선택한 건강정보의 의료진 제공 지원<br>
        ④ 전송요구 내역, 연동기관, 연동항목, 전송·공유 이력 관리<br>
        ⑤ 회원 문의, 장애 대응, 서비스 품질 개선<br>
        ⑥ 관계 법령 및 가이드라인에 따른 기록 보관, 전송 내역 통지, 안전성 확보 조치<br>
        3. 회사는 회원의 건강정보를 회원이 동의한 목적 범위 내에서만 이용하며, 동의받은 목적을 벗어나 이용하지 않습니다.<br>
        4. 맞춤형 건강 서비스, AI 리포트 생성, 마케팅 활용 등 별도 동의가 필요한 서비스는 회원이 해당 서비스 이용에 동의한 경우에 한하여 제공됩니다. 회사는 해당 서비스를 제공하기 전에 회원으로부터 별도의 동의를 받아 처리합니다.<br>
        <h3>제9조 (민감정보 처리)</h3>
        1. 회사는 솔닥 마이데이터 서비스 제공을 위하여 회원의 건강에 관한 정보 등 민감정보를 처리할 수 있습니다.<br>
        2. 회사가 처리하는 민감정보는 회원이 전송요구한 항목 및 동의한 범위에 한정됩니다.<br>
        3. 회사는 민감정보를 일반 개인정보와 구분하여 처리하며, 관계 법령에 따라 필요한 안전성 확보 조치를 이행합니다.<br>
        <h3>제10조 (보유 및 이용기간)</h3>
        1. 회사는 회원이 솔닥 마이데이터 서비스를 이용하는 기간 동안 회원의 건강정보를 보유·이용할 수 있습니다.<br>
        2. 회사는 회원이 마이데이터 연동을 해지하거나, 전송요구를 철회하거나, 솔닥 회원을 탈퇴하는 경우 관련 법령에 따라 보관해야 하는 정보를 제외하고 전송받은 건강정보를 지체 없이 삭제 또는 파기합니다.<br>
        3. 전송요구 이력, 전송·수신 기록, 제3자 제공 동의 및 제공 내역 등 관계 법령 또는 가이드라인에 따라 보관이 필요한 정보는 정해진 기간 동안 보관할 수 있습니다.<br>
        4. AI 요약, 건강 리포트, 건강나이 등 건강정보를 기반으로 생성된 2차 가공 정보가 특정 개인을 식별할 수 있는 정보에 해당하는 경우, 해당 정보도 개인정보 또는 민감정보로 보아 본 조에 따라 처리합니다.<br>
        <h3>제11조 (전송요구 철회 및 연동 해지)</h3>
        1. 회원은 솔닥 마이데이터 관리 화면 또는 회사가 정한 절차를 통해 전송요구를 철회하거나 연동을 해지할 수 있습니다.<br>
        2. 회원이 전송요구를 철회하거나 연동을 해지하는 경우 회사는 해당 전송요구에 따른 신규 건강정보 조회를 중단합니다.<br>
        3. 회사는 전송요구 철회 또는 연동 해지 시 해당 전송요구에 따라 수신한 건강정보와 해당 정보를 기반으로 생성한 식별 가능한 2차 가공 정보를 관련 법령에 따라 삭제 또는 파기합니다.<br>
        4. 이미 회원의 별도 동의에 따라 의료기관, 의료진 또는 EMR 등 제3자에게 제공된 정보는 해당 제공받는 자의 법적 의무 및 보유 기준에 따라 처리될 수 있습니다. 이 경우 회사는 해당 제3자의 시스템 내 정보를 임의로 삭제하지 않을 수 있습니다.<br>
        <h2>제4장 의료진 제공 및 제3자 제공</h2>
        <h3>제12조 (건강정보의 의료진 제공)</h3>
        1. 회사는 회원이 진료 예약, 진료 접수, 비대면 진료, 대면 진료 등 과정에서 건강정보 공유를 선택한 경우, 회원이 선택한 건강정보를 해당 의료기관, 의료진 또는 EMR 시스템에 제공할 수 있습니다.<br>
        2. 회사는 건강정보를 제3자에게 제공하기 전에 제공받는 자, 제공 목적, 제공 항목, 보유 및 이용기간을 회원에게 고지하고 별도 동의를 받습니다.<br>
        3. 회사는 회원이 선택하거나 동의한 항목에 한하여 건강정보를 제공하며, 회원이 동의하지 않은 건강정보를 의료기관, 의료진 또는 EMR 시스템에 제공하지 않습니다.<br>
        4. 의료진 제공 동의는 실제 진료 목적과 제공받는 자, 제공 항목이 특정되는 시점에 받을 수 있습니다.<br>
        <h3>제13조 (전송·공유 이력 관리)</h3>
        1. 회사는 회원의 전송요구 내역, 연동기관, 연동항목, 전송요구 기간, 정기전송 여부 및 주기, 전송요구 변경·철회 내역, 제3자 제공 동의 및 제공 내역을 관계 법령 및 서비스 정책에 따라 보관·관리할 수 있습니다.<br>
        2. 회원은 솔닥 마이데이터 관리 화면에서 본인의 전송요구 내역 및 제3자 제공 이력을 확인할 수 있습니다.<br>
        3. 회사는 전송요구 및 전송내역에 대한 기록을 회원에게 연 1회 이상 이메일, 앱 푸시(PUSH) 알림, 문자 메시지 등을 이용하여 통지합니다. 회원은 솔닥 마이데이터 관리 화면에서 통지 받기를 거부할 수 있습니다.<br>
        <h2>제5장 맞춤형 서비스 및 AI 활용</h2>
        <h3>제14조 (맞춤형 건강 서비스)</h3>
        1. 회사는 회원이 별도로 동의한 경우, 전송받은 건강정보를 활용하여 맞춤형 건강 콘텐츠, 건강관리 프로그램, 서비스 추천 등 맞춤형 건강 서비스를 제공할 수 있습니다.<br>
        2. 맞춤형 건강 서비스 제공 동의는 솔닥 마이데이터 기본 조회 서비스 이용 동의와 구분하여 받습니다.<br>
        3. 회원이 맞춤형 건강 서비스 제공에 동의하지 않더라도, 기본적인 마이데이터 조회 기능 이용에는 제한이 없습니다.<br>
        <h3>제15조 (AI 리포트 및 AI 가공)</h3>
        1. 회사는 회원이 별도로 동의한 경우, 전송받은 건강정보를 AI 또는 자동화된 방식으로 요약·가공하여 건강 리포트, AI 요약 정보, 건강나이 등 2차 가공 정보를 생성할 수 있습니다.<br>
        2. AI 리포트 또는 AI 요약 정보는 회원의 건강정보 이해를 돕기 위한 참고자료이며, 의료진의 진단 또는 처방을 대체하지 않습니다.<br>
        3. 회사가 AI 리포트 또는 AI 요약 정보를 의료기관, 의료진 또는 EMR 시스템에 제공하는 경우, 회원에게 별도의 제3자 제공 동의를 받습니다.<br>
        4. 외부 AI API 또는 LLM을 활용하는 경우 회사는 관계 법령에 따라 처리위탁, 국외 이전, 개인정보처리방침 공개 등 필요한 조치를 이행합니다.<br>
        5. 회원이 AI 리포트 서비스 제공에 동의하지 않더라도, 기본적인 마이데이터 조회 기능 이용에는 제한이 없습니다.<br>
        <h2>제6장 회원의 의무 및 서비스 제한</h2>
        <h3>제16조 (회원의 의무)</h3>
        회원은 솔닥 마이데이터 서비스를 이용함에 있어 다음 각 호의 행위를 하여서는 안 됩니다.<br>
        1. 타인의 개인정보 또는 건강정보를 본인의 정보인 것처럼 연동하는 행위<br>
        2. 타인의 인증정보를 이용하여 마이데이터 연동을 시도하는 행위<br>
        3. 본인의 프로필 정보를 허위로 입력하거나 부정확하게 입력하는 행위<br>
        4. 회사 또는 제3자의 권리, 명예, 신용을 침해하는 행위<br>
        5. 서비스의 정상적인 운영을 방해하는 행위<br>
        6. 관계 법령 또는 이 약관을 위반하는 행위<br>
        <h3>제17조 (서비스 이용 제한)</h3>
        1. 회사는 다음 각 호의 어느 하나에 해당하는 경우 솔닥 마이데이터 서비스의 전부 또는 일부 이용을 제한할 수 있습니다.<br>
        ① 회원의 본인 확인이 완료되지 않은 경우<br>
        ② 회원의 인증정보와 솔닥 본인 프로필 정보가 일치하지 않는 경우<br>
        ③ 회원이 타인의 개인정보 또는 건강정보를 연동하려는 경우<br>
        ④ 보건의료정보전송자 또는 중계전문기관의 사정으로 건강정보 전송이 불가능한 경우<br>
        ⑤ 관계 법령, 가이드라인 또는 이 약관을 위반한 경우<br>
        ⑥ 서비스 장애, 점검, 보안상 위험 등으로 서비스 제공이 어려운 경우<br>
        ⑦ 기타 정전, 천재지변, 국가비상사태 등 불가항력적 사유가 발생한 경우<br>
        2. 회사는 제1항에 따라 서비스 이용을 제한하는 경우에는 그 사유와 내용을 서비스 화면에 게시하여 회원에게 알립니다. 단 서비스 장애복구, 긴급한 점검, 외부 요인 등 불가피한 경우에는 예외로 합니다.<br>
        3. 회사는 서비스 이용 제한 사유가 해소된 경우 서비스 이용을 재개할 수 있습니다.<br>
        4. 서비스는 개인정보보호법, 의료법 등 관련 법령 개정 및 정책 변화에 따라 달라질 수 있으며, 그 과정에서 관련 법령 및 정책상 서비스 제공이 어려운 상당한 이유가 있는 경우에는 서비스 전체 또는 일부의 제공을 일시적으로 중단할 수 있습니다.<br>
        <h3>제18조 (전송 거절 및 중단)</h3>
        회사는 다음 각 호의 경우 회원의 건강정보 전송요구를 거절하거나 중단할 수 있습니다.<br>
        1. 본인인증 실패 등 회원 본인이 전송요구를 한 사실이 확인되지 않은 경우<br>
        2. 타인의 인증정보를 탈취하거나 본인에 관하여 허위 정보를 입력하는 등 부당한 방법으로 전송요구를 한 경우<br>
        3. 회원 본인이 제3자의 기망이나 협박 등으로 인하여 전송요구를 한 경우<br>
        4. 전송요구에 응하여 건강정보를 제공할 경우 관계 법령에 위반되거나 제3자의 권리, 명예, 신용, 이익 등을 침해할 우려가 있는 경우<br>
        <h2>제7장 책임 제한 및 기타</h2>
        <h3>제19조 (책임 제한)</h3>
        1. 회사는 보건의료정보전송자 또는 중계전문기관 등 건강정보 제공 및 중계 서비스 제공 기관의 사정으로 건강정보 전송이 지연되거나 실패한 경우, 회사의 고의 또는 중대한 과실이 없는 한 이에 대한 책임을 지지 않습니다.<br>
        2. 회사는 보건의료정보전송자로부터 제공받은 건강정보의 정확성, 최신성, 완전성에 대해 회사의 고의 또는 중대한 과실이 없는 한 책임을 지지 않습니다.<br>
        3. 회사는 회원의 귀책사유로 인한 마이데이터 연동 실패, 정보 오류, 서비스 이용 장애에 대해 책임을 지지 않습니다.<br>
        4. 회사는 AI 요약, 건강 리포트 등 참고 정보의 이용으로 인해 발생한 결과에 대해 회사의 고의 또는 중대한 과실이 없는 한 책임을 지지 않습니다.<br>
        5. 회사는 회원이 서비스를 통해 조회한 자신의 건강정보를 참고하여 회원 본인의 결정으로 받은 진료·수술·처방·검사·거래 등과 관련하여 발생한 결과에 대해 회사의 고의 또는 중대한 과실이 없는 한 책임을 지지 않습니다.<br>
        6. 회사는 의료기관 또는 의료진이 독립적인 개인정보처리자로서 처리하는 정보에 대해서는 해당 의료기관 또는 의료진의 책임 범위에 따릅니다.<br>
        <h3>제20조 (손해배상)</h3>
        1. 회사는 관련 법령상 허용되는 한도 내에서, 본 약관에 명시되지 않은 사항에 대하여 별도의 약정이나 보증을 하지 않습니다.<br>
        2. 회사는 보건의료정보전송자, 중계전문기관 또는 관계 기관으로부터 전송받은 건강정보의 정확성, 최신성, 완전성에 대하여 보증하지 않습니다. 또한 회원이 직접 입력하거나 수정한 정보, 회원이 선택한 연동 항목, 회원이 동의한 제공 항목, 회원의 서비스 이용 방식으로 인해 발생한 손해에 대하여 회사의 고의 또는 과실이 없는 한 책임을 부담하지 않습니다.<br>
        3. 회원이 본 약관 또는 관계 법령을 위반하거나, 타인의 개인정보 또는 건강정보를 부정하게 이용하거나, 허위 또는 부정확한 정보를 입력함으로써 회사 또는 제3자에게 손해가 발생한 경우, 회원은 그 손해를 배상하여야 합니다.<br>
        4. 회원이 서비스를 이용하는 과정에서 행한 불법행위 또는 본 약관 위반행위로 인하여 회사가 제3자로부터 손해배상 청구, 민원, 분쟁, 소송 또는 기타 이의 제기를 받은 경우, 해당 회원은 자신의 책임과 비용으로 회사를 면책하여야 합니다. 회사가 면책되지 못한 경우 회원은 그로 인하여 회사에 발생한 손해를 배상하여야 합니다.<br>
        5. 회원 간 또는 회원과 의료기관, 의료진, 제휴기관 등 제3자 간에 서비스 이용과 관련하여 분쟁이 발생한 경우, 회사는 회사의 고의 또는 과실이 없는 한 그 분쟁에 대하여 책임을 부담하지 않습니다.<br>
        6. 회사가 본 약관 또는 관계 법령을 위반하거나 회사의 고의 또는 과실로 회원에게 손해가 발생한 경우, 회사는 관련 법령에 따라 회원에게 발생한 손해를 배상합니다.<br>
        <h2>부칙</h2>
        <h3>제1조 (시행일)</h3>
        이 약관은 2026년 00월 00일부터 시행합니다.
    </div>
</template>

<script>
export default {
    name: 'mydataTerms'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/mydata/Terms.vue